import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState, Zona } from '../../../helpers';

import { NavContext, NavRoutes } from '../../contexts';

import useUnsavedChangesWarning from "../../common/hooks/useUnsavedChangesWarning";

export const UfficioContext = React.createContext(null);

const { Provider } = UfficioContext;

export const UfficioProvider = (props) => {
    const {
        navigateTo,
        getRouteTo,
        compileRoute
    } = useContext(NavContext);

    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { utente, fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        ufficio: null,
        comuni: null,
        comuniOptions: [],
        tipi: null,
        tipiOptions: [],
        uffici: null,
        ufficiOptions: [],
        contatti: [],
        storici: [],
    });

    const {
        ufficio,
        uffici,
        contatti,
    } = state;

    const [isLoadingUfficio, setIsLoadingUfficio] = useState(false);
    const getUfficioAsync = async (ufficioId) => {
        try {
            setIsLoadingUfficio(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetUfficio({ ufficioId }), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            result.inizioValidita = new Date(result.inizioValidita);
            result.fineValidita = result.fineValidita ? new Date(result.fineValidita) : null;
            setState({ ufficio: result, contatti: result.contatti });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUfficio(false);
        }
    }

    const [isUpdatingUfficio, setIsUpdatingUfficio] = useState(false);
    const updateUfficioAsync = async (ufficioId, ufficio) => {
        try {
            setIsUpdatingUfficio(true);
            if (window.confirm("Confermare la modifica?")) {
                const r = await fetchAuthorized(ApiRoutes.Ufficio.UpdateUfficio({ ufficioId }), {
                    method: HttpMethods.POST,
                    body: JSON.stringify(ufficio),
                });
                const result = await r.json();
                setState({ ufficio: result });
                showSuccessMessage("Ufficio aggiornato");
                window.close();
            }

        } catch (e) {
            console.debug(e);
        } finally {
            setIsUpdatingUfficio(false);
        }
    }

    const [isAddingUfficio, setIsAddingUfficio] = useState(false);
    const addUfficioAsync = async (ufficio) => {
        try {
            setIsAddingUfficio(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.AddUfficio(), {
                method: HttpMethods.PUT,
                body: JSON.stringify(ufficio),
            });
            const result = await r.json();
            showSuccessMessage("Ufficio creato");
            window.open(getRouteTo(NavRoutes.Ufficio, [result.id]), "_blank").focus()
            // navigateTo(compileRoute(NavRoutes.Ufficio, [result.id]));
            window.close();
        } catch (e) {
            console.debug(e);
        } finally {
            setIsAddingUfficio(false);
        }
    }

    const [isLoadingComuni, setIsLoadingComuni] = useState(false);
    const getComuniAsync = async (term = null, valid = false, pageIndex = 0, pageSize = 100) => {
        try {
            setIsLoadingComuni(true);
            const r = await fetchAuthorized(ApiRoutes.Comune.GetComuni({ pageIndex, pageSize, term, valid: valid }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result.forEach(x => {
                x.dataIstituzione = new Date(x.dataIstituzione);
                x.dataCessazione = x.dataCessazione ? new Date(x.dataCessazione) : null;
            });
            setState({ comuni: list, comuniOptions: list.result.map(e => { return { comuneId: e.id, label: `${e.denominazioneIt} (${e.provincia.sigla}) ${e.dataCessazione ? `(${e.dataCessazione.getDate()}-${e.dataCessazione.getMonth() + 1}-${e.dataCessazione.getFullYear()})` : ""}` } }).sort((a, b) => a.label.localeCompare(b.label)) });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingComuni(false);
        }
    }

    const [isLoadingTipi, setIsLoadingTipi] = useState(false);
    const getTipiAsync = async (pageIndex = 0, pageSize = 100) => {
        try {
            setIsLoadingTipi(true);
            const r = await fetchAuthorized(ApiRoutes.TipoUfficio.GetTipiUffici({ pageIndex, pageSize }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result = list.result.map(e => { return { ...e, inizioValidita: new Date(e.inizioValidita), fineValidita: e.fineValidita ? new Date(e.fineValidita) : null, } });
            setState({ tipi: list, tipiOptions: list.result.map(e => { return { tipoUfficioId: e.id, label: `${e.nome}` } }).sort((a, b) => a.label.localeCompare(b.label)) });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingTipi(false);
        }
    }

    const [isLoadingUffici, setIsLoadingUffici] = useState(false);
    const getUfficiAsync = async (term = null, pageIndex = 0, pageSize = 100, zona = Zona.Distretto) => {
        try {
            setIsLoadingUffici(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetUffici(), {
                method: HttpMethods.POST,
                body: JSON.stringify({ pageIndex, pageSize, zona }),
            });
            const list = await r.json();
            setState({ uffici: list, ufficiOptions: list.result.map(e => { return { ufficioId: e.id, label: `${e.nome}` } }).sort((a, b) => a.label.localeCompare(b.label)) });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUffici(false);
        }
    }

    const [isDeletingContatto, setIsDeletingContatto] = useState(false);
    const deleteContattoAsync = async (ufficioId, contattoId) => {
        try {
            setIsDeletingContatto(true);
            if (window.confirm("Confermare l'eliminazione del attributo?")) {
                const r = await fetchAuthorized(ApiRoutes.Ufficio.DeleteContatto({ ufficioId, contattoId }), {
                    method: HttpMethods.DELETE
                });
                setState({ contatti: contatti.filter(x => x.id != contattoId) });
                showSuccessMessage(`Attributo con id ${contattoId} dell'ufficio con id ${ufficioId} eliminato`);
            }

        } catch (e) {
            console.debug(e);
        } finally {
            setIsDeletingContatto(false);
        }
    }

    const [isLoadingStorici, setIsLoadingStorici] = useState(false);
    const getStoriciAsync = async (ufficioId, pageIndex = 0, pageSize = 1000,) => {
        try {
            setIsLoadingStorici(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetStorici({ pageIndex, pageSize, ufficioId }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result = list.result.map(e => { return { ...e, dataCreazione: new Date(e.dataCreazione) } });
            setState({ storici: list, });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingStorici(false);
        }
    }

    const [Prompt, setDirty, setPristine] = useUnsavedChangesWarning();

    const [isLockingUfficio, setIsLockingUfficio] = useState(false);
    const lockUfficioAsync = async (ufficioId) => {
        try {
            setIsLockingUfficio(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.LockUfficio({ ufficioId }), {
                method: HttpMethods.POST,
            });

            const result = await r.json();
            setState({ isLockedBy: result.result })

            if (result.result !== "") {
                // setPristine();
                alert(`Ufficio bloccato da ${result.result}, l'ufficio verrà aperto in sola lettura`)
                navigateTo(getRouteTo(NavRoutes.Ufficio, [ufficioId]) + "?solaLettura=true");
            }

        } catch (e) {
            console.debug(e);
        } finally {
            setIsLockingUfficio(false);
        }
    }

    const [isUnlockingUfficio, setIsUnlockingUfficio] = useState(false);
    const unlockUfficioAsync = async (ufficioId, close, showMessage, forceUnlock) => {
        try {
            setIsUnlockingUfficio(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.UnlockUfficio({ ufficioId }), {
                method: HttpMethods.POST,
                body: JSON.stringify({ forceUnlock })
            });
            const result = await r.json();
            if (close)
                window.close();

            if (showMessage && result) {
                showSuccessMessage("Ufficio sbloccato");
                navigateTo(compileRoute(NavRoutes.Ufficio, [ufficioId]) + "?solaLettura=true");
            } else if (showMessage) {
                showErrorMessage("Ufficio non sbloccato perchè preso in carico da un altro utente");
            }

            setState({ isLockedInReadonly: !result.result })

        } catch (e) {
            console.debug(e);
        } finally {
            setIsUnlockingUfficio(false);
        }
    }


    return (
        <Provider value={{
            state,
            setState,

            isLoadingUfficio,
            getUfficioAsync,

            isUpdatingUfficio,
            updateUfficioAsync,

            isAddingUfficio,
            addUfficioAsync,

            isLoadingTipi,
            getTipiAsync,

            isLoadingComuni,
            getComuniAsync,

            isLoadingUffici,
            getUfficiAsync,

            isDeletingContatto,
            deleteContattoAsync,

            isLoadingStorici,
            getStoriciAsync,

            isLockingUfficio,
            lockUfficioAsync,

            isUnlockingUfficio,
            unlockUfficioAsync,

            setPristine,
            setDirty,
            Prompt
        }}>
            {props.children}
        </Provider>
    );
}